import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const getDraftAmendsByReferenceIdAndType = api(
    function getDraftAmendsByReferenceIdAndType(referenceId, type, filter, projectId) {
        if (!projectId || !referenceId || !type) return []

        return query(
            gql`
                query GetDraftAmendsByReferenceIdAndType(
                    $projectId: String!
                    $referenceId: String!
                    $type: String!
                    $filter: JSONObject
                ) {
                    getDraftAmendsByReferenceIdAndType(
                        projectId: $projectId
                        referenceId: $referenceId
                        type: $type
                        filter: $filter
                    ) {
                        id
                        shortDescription
                        longDescription
                        referenceId
                        type
                        date
                        userId
                        userName
                        payload
                    }
                }
            `,
            { projectId, referenceId, type, filter },
            { returns: "getDraftAmendsByReferenceIdAndType" }
        )
    }
)
